export function InlineCode({ content }: { content: string }) {
  return (
    <span className="break-words rounded bg-slate-700 px-0.5">
      <code className="font-mono text-sky-300">{content}</code>
    </span>
  )
}
